import React from 'react';
import { useTranslation } from 'react-i18next';
import ArrowDownIcon from '../../assets/icons/ArrowDownIcon';
import ArrowUpIcon from '../../assets/icons/ArrowUpIcon';
import { COLORS } from '../../styles/variables';
import {
  ExposedButton,
  FilterHeader,
  FilterTitle,
  FilterListWrapper,
  GreenDot,
  FilterList,
} from './Filters.style';
import { ExposedFiltersTypes } from '../../constants/initialFilters';

interface FilterExposedHeaderTypes {
  filterType: string;
  selectedFilterLabels: string;
  openedFiltersList: ExposedFiltersTypes;
  handleExposeFilter: (arg: string) => void;
}

const FilterExposedHeader: React.FC<FilterExposedHeaderTypes> = ({
  filterType,
  selectedFilterLabels,
  handleExposeFilter,
  openedFiltersList,
}) => {
  const { t } = useTranslation();
  return (
    <ExposedButton
      data-testid="expose-button"
      tabIndex={0}
      onClick={() => handleExposeFilter(filterType)}
    >
      <FilterHeader>
        <FilterTitle data-testid="filter-title">
          {t(`promo.filters.filterOptions.${filterType}.title`)}
        </FilterTitle>
        {selectedFilterLabels && (
          <FilterListWrapper>
            <GreenDot />
            <FilterList>{selectedFilterLabels}</FilterList>
          </FilterListWrapper>
        )}
      </FilterHeader>
      {openedFiltersList[filterType] ? (
        <ArrowUpIcon color={COLORS.black} />
      ) : (
        <ArrowDownIcon color={COLORS.black} />
      )}
    </ExposedButton>
  );
};

export default FilterExposedHeader;
